import { Routes } from '@angular/router';

export const ENTRADA_SAIDA_ROUTES: Routes = [
	{
		path: 'entrada-saida',
		loadComponent: () =>
			import('./feature-entrada-saida/entrada-saida').then((m) => m.EntradaSaida),
		data: { title: 'Entrada/saída' },
	},
];
